import { render, staticRenderFns } from "./LinkYoutube.vue?vue&type=template&id=648f4d38&scoped=true&"
import script from "./LinkYoutube.vue?vue&type=script&lang=js&"
export * from "./LinkYoutube.vue?vue&type=script&lang=js&"
import style0 from "./LinkYoutube.vue?vue&type=style&index=0&id=648f4d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f4d38",
  null
  
)

export default component.exports